import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Box, Flex, Text, ButtonFilled, Image } from 'Components/Base';

const ImageWrapper = styled(Box)`
  margin: 0 auto;
  max-width: 80vw;
  @media (min-width: 768px) {
    max-width: 30vw;
  }
  @media (max-width: 768px) and (orientation: landscape) {
    display: none;
  }
`;

const NavButton = (props) => <ButtonFilled fontSize={1} minWidth="150px" {...props} />;

const ComingSoonView = ({ t, onNextClick, onPreviousClick, imageUrl, ...props }) => {
  const isShowPreviousButton = typeof onPreviousClick === 'function';
  const isShowNextButton = typeof onNextClick === 'function';

  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center" {...props}>
      {imageUrl && (
        <ImageWrapper>
          <Image src={imageUrl} />
        </ImageWrapper>
      )}
      <Text fontWeight="medium" textAlign="center" mt={4}>
        {t('CONTENT.COMING_SOON')}
      </Text>
      <Flex mt={4} justifyContent="center" alignItems="center" maxWidth={'720px'}>
        {isShowPreviousButton && (
          <NavButton onClick={onPreviousClick} mr={isShowNextButton ? 2 : 0}>
            {t('CONTENT.PREVIOUS_SUBSECTION')}
          </NavButton>
        )}
        {isShowNextButton && (
          <NavButton onClick={onNextClick}>{t('CONTENT.NEXT_SUBSECTION')}</NavButton>
        )}
      </Flex>
    </Flex>
  );
};

ComingSoonView.propTypes = {
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  imageUrl: PropTypes.string,
};

export default withTranslation('classroom')(ComingSoonView);
